module.exports = __webpack_public_path__ + "img/logo.a4ca1c1e.png";